// src/App.jsx
import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import GameWrapper from "./Componants/frontend/GameWrapper.jsx"; // Import the GameWrapper component
import DetailPage from "./Componants/DetailPage"; // Import the DetailPage component
import GameList from "./Componants/Backend/GameList"; // Import the GameList component
import AddCategory from "./Componants/Backend/AddCategory";
import User from "./Componants/User"; // Import the User component
import Dashboard from "./Dashboard"; // Import the Dashboard component
import GamePageLayout from "./Componants/frontend/GamePageLayout";
import Register from "./Componants/Backend/Auth/Register";
import Layout from "./Componants/frontend/Layout";
import ProtectedRoute from "./Componants/Backend/ProtectedRoute";
import SearchGameWrapper from "./Componants/frontend/SearchGameWrapper";
import AddBlog from "./Componants/Backend/AddBlog";

// Context Provider
import AppProvider from "./context/AppContext";
import CategoryWrapper from "./Componants/frontend/CategoryWrapper";
import CreateMenuBar from "./Componants/Backend/CreateMenuBar";
import Login from "./Componants/Backend/Auth/Login";
import usePageTracking from "./Componants/frontend/hooks/usePageTracking";
import { HelmetProvider } from "react-helmet-async";
import AdvertiseForm from "./Componants/Backend/AdvertiseForm";
import Blog from "./Componants/frontend/Blog";
import BlogDetails from "./Componants/frontend/BlogDetails";
import MenuWrapper from "./Componants/frontend/MenuWrapper";
import PrivacyPolicy from "./Componants/frontend/PrivacyPolicy";
import Aboutus from "./Componants/frontend/Aboutus";
import TermOfUse from "./Componants/frontend/TermOfUse.jsx";
function App() {
  useEffect(() => {
    const timer = setTimeout(() => {
      // Load Ads
      var ads = document.createElement("script");
      ads.src =
        "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7616427419210158";
      ads.async = true;
      ads.crossOrigin = "anonymous";
      document.head.appendChild(ads);

      // Load Analytics
      const gtagScript = document.createElement("script");
      gtagScript.src =
        "https://www.googletagmanager.com/gtag/js?id=G-73XSM2HCK5";
      gtagScript.async = true;
      document.head.appendChild(gtagScript);

      gtagScript.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        window.gtag = gtag;
        gtag("js", new Date());
        gtag("config", "G-73XSM2HCK5");
      };
    }, 5000);

    return () => clearTimeout(timer);
  }, []);
  return (
    <HelmetProvider>
      <AppProvider>
        <BrowserRouter>
          <PageTracker />
          <Routes>
            <Route path="/">
              <Route element={<PrivacyPolicy />} />
              <Route element={<Layout />}>
               
                <Route index element={<GameWrapper />} />
                <Route path="/:categoryName" element={<CategoryWrapper />} />
                <Route path="/menu/:categoryName" element={<MenuWrapper />} />
                <Route
                  path="/search/:gameName"
                  element={<SearchGameWrapper />}
                />
                <Route path="/game/:gamePath" element={<GamePageLayout />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:id" element={<BlogDetails />} />
                <Route path="/details" element={<DetailPage />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/about" element={<Aboutus />} />
                <Route path="/terms" element={<TermOfUse />} />
              </Route>
            </Route>
            <Route path="/backbone" element={<Dashboard />}>
              <Route index element={<Navigate to="login" replace />} />
              <Route
                path="gamelist"
                element={
                  <ProtectedRoute>
                    <GameList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="addCategory"
                element={
                  <ProtectedRoute>
                    <AddCategory />
                  </ProtectedRoute>
                }
              />
              <Route
                path="saveuser"
                element={
                  <ProtectedRoute>
                    <User />
                  </ProtectedRoute>
                }
              />
              <Route path="register" element={<Register />} />
              <Route
                path="createmenu"
                element={
                  <ProtectedRoute>
                    <CreateMenuBar />
                  </ProtectedRoute>
                }
              />
              <Route
                path="addvertise"
                element={
                  <ProtectedRoute>
                    <AdvertiseForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="blog"
                element={
                  <ProtectedRoute>
                    <AddBlog />
                  </ProtectedRoute>
                }
              />
              <Route path="login" element={<Login />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </HelmetProvider>
  );
}
function PageTracker() {
  usePageTracking();
  return null;
}
export default App;
